/**
 * this is the App entry point for react
 * the primary component used in AppRouter is exported from here
 */

import React, { memo, useEffect } from "react";
import { Outlet } from "react-router";
import { useSessionContext } from "@/contexts/sessionContext";
import { JSToastContainer } from "./components/toast";

import "./App.scss";
import "./styles/Style.css";
import "./styles/Theme.css";
import "./styles/Navigation.scss";
import "./styles/Ltheme.css";
import { eventTracker } from "@/services/eventTrackingServices";

/**
 * this is the root wrapper for all routes
 *
 * we need this, so we can have any scripts, modals
 * or anything else globally for all routes
 *
 * NOTE - this wraps login, forgot password, unsubscribe, etc
 * so, we cannot add anything here that requires session
 *
 * this has the toast container for toasts
 */
export const RootLayout = memo(() => {
  console.log("RootLayout render - rerender");
  return (
    <>
      <Outlet />
      <JSToastContainer />
    </>
  );
});
RootLayout.displayName = "RootLayout";

export const EventTrackerComponent = memo(() => {
  const { isMasterPasswordLogin, isAdminLogin, demoUser } = useSessionContext();
  useEffect(() => {
    if (isMasterPasswordLogin || isAdminLogin || demoUser) return;
    eventTracker.initialize();
  }, [isAdminLogin, isMasterPasswordLogin, demoUser]);

  return null;
});
EventTrackerComponent.displayName = "EventTrackerComponent";
